import http from "services/http";

export interface AnalyticsResponse {
  success: boolean;
  message: string;
  data: {
    stats: {
      totalFlightCustomers: number;
      totalFlightSales: number;
      totalFlightTrip: number;
      totalRideSales: number;
      totalRideTrip: number;
      flightSales: {
        months: Array<{
          value: number;
          bookings: number;
          month: string;
        }>;
        days: Array<{
          value: number;
          bookings: number;
          day: string;
        }>;
      };
      rideSales: {
        months: Array<{
          value: number;
          bookings: number;
          month: string;
        }>;
        days: Array<{
          value: number;
          bookings: number;
          day: string;
        }>;
      };
      bookingTrend: {
        monthlyBreakdown: Array<{
          month: string;
          completed: number;
          pending: number;
          failed: number;
        }>;
        percentages: {
          successRate: number;
          pendingRate: number;
          failureRate: number;
        };
      };
      customerBreakdown: {
        newCustomers: number;
        returningCustomers: number;
        newCustomersPercentage: number;
        returningCustomersPercentage: number;
      };
      topAirlines: Array<{
        bookings: number;
        revenue: number;
        airline: string;
      }>;
      topFlightDestinations: Array<{
        trips: number;
        revenue: number;
        destination: string;
      }>;
      topRideDestinations: Array<{
        trips: number;
        revenue: number;
        destination: string;
      }>;
      revenueTrend: Array<{
        month: string;
        year: number;
        flightRevenue: number;
        rideRevenue: number;
        total: number;
      }>;
    };
  };
}

export const getAnalyticsData = async (
  startDate: string,
  endDate: string,
): Promise<AnalyticsResponse> => {
  const response = await http.get(
    `/admin/dashboard/analytics/${startDate}/${endDate}`,
  );
  return response.data;
};

export type CustomerType = "all" | "new" | "returning";

export interface DashboardCustomer {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  type: "new" | "returning";
  totalBookings: number;
  firstBookingDate: string;
  lastBookingDate: string;
  lastPnr: string;
  lastRoute: string;
}

export interface DashboardCustomersQuery {
  type: CustomerType;
  search?: string;
  page: number;
  limit: number;
}

export interface DashboardCustomersResponse {
  success: boolean;
  message: string;
  data: {
    type: CustomerType;
    counts: {
      total: number;
      new: number;
      returning: number;
    };
    customers: DashboardCustomer[];
    pagination?: {
      page?: number;
      limit?: number;
      total?: number;
      pages?: number;
      totalPages?: number;
    };
  };
}

export const getDashboardCustomers = async ({
  type,
  search,
  page,
  limit,
}: DashboardCustomersQuery): Promise<DashboardCustomersResponse> => {
  const response = await http.get("/admin/dashboard/customers", {
    params: { type, page, limit, ...(search ? { search } : {}) },
  });
  return response.data;
};
